import { render, staticRenderFns } from "./merchant-cate.vue?vue&type=template&id=c9bfa446&scoped=true&"
import script from "./merchant-cate.vue?vue&type=script&lang=js&"
export * from "./merchant-cate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bfa446",
  null
  
)

export default component.exports